/**
 * 创建人：zll
 * 时间：2020-12-18
 * 描述：input标签聚焦点时，边框显示，失焦点时只显示底边框
 * 更新记录: 
 */
import { Directive, HostListener, ElementRef } from '@angular/core';


/**
 * input标签聚焦点时，边框显示，失焦点时只显示底边框
 * 
 * @example <input SwFoucsBlur />
 */
@Directive({
  selector: '[SwFoucsBlur]'
})
export class SwFoucsBlurDirective {

  /**
   * @ignore
   */
  constructor(private el: ElementRef) { }

  ngOnInit(): void {
   
  }


  /**
   * @ignore
   */
  // @HostListener('click', ['$event']) onClick(event) {
  
  // }
}
